import { Controller } from "@hotwired/stimulus";
import { CsrfToken } from "../shared/csrf_token";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";

// Connects to data-controller="resumin--image-preview"
export default class extends Controller {
  static targets = ["fileInput", "removeFlg"];

  connect() {
    CsrfToken(this);
    TurboStreamHeaders(this);
  }

  selectFile(e) {
    e.preventDefault();
    this.fileInputTarget.click();
  }

  preview(e) {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append(e.target.name, file);

    fetch("/entry_sheet_previews", {
      method: "POST",
      body: formData,
      headers: {
        ...this.csrfToken(),
        ...this.turboStreamHeaders(),
      },
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((errorMessage) => {
            throw new Error(
              errorMessage.error || "Network response was not ok"
            );
          });
        }
        return response.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);
        this.removeFlgTarget.value = "false";
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        alert(error.message);

        // 依存関係が強いがfileInputに指定したイベントを発火させる
        const event = new CustomEvent("imagePreview:error", {
          detail: { e: e },
        });
        this.fileInputTarget.dispatchEvent(event);
        this.fileInputTarget.value = "";
      });
  }

  remove(e) {
    e.preventDefault();

    fetch("/entry_sheet_previews", {
      method: "DELETE",
      headers: {
        ...this.csrfToken(),
        ...this.turboStreamHeaders(),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);
        this.removeFlgTarget.value = "true";
        this.fileInputTarget.value = "";
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }
}
